<script setup lang="ts">
import { computed, onMounted } from 'vue';

import { languagesInfo } from '@/constants';
import { useLocale } from '@/hooks';

const { initialLocale, setLocale } = useLocale();

const selectedLocale = computed({
  get: () => initialLocale,
  set: setLocale
});

onMounted(() => setLocale(initialLocale));
</script>

<template>
  <Vueform>
    <SelectElement
      name="Languages"
      class="language-switcher"
      :items="languagesInfo"
      :native="false"
      :can-clear="false"
      :can-deselect="false"
      :default="selectedLocale"
      @change="setLocale"
    >
      <template #option="{ option }: { option: { value: string; label: string; flag: string } }">
        <div class="flex items-center gap-2">
          <img :src="option.flag" alt="" class="w-5 h-5" />
          <span>{{ option.label }}</span>
        </div>
      </template>

      <template #single-label="{ value }: { value: { value: string; label: string; flag: string } }">
        <div class="flex items-center gap-2 pointer-events-none">
          <img :src="value?.flag" alt="" class="w-5 h-6 ml-3" />
          <span>{{ value?.label }}</span>
        </div>
      </template>

      <template #caret="{ isOpen }: { isOpen: boolean }">
        <Icon
          icon-name="chevronDown"
          class="w-4 h-4 mr-3 ml-1 transition-transform"
          :class="{ 'rotate-180': isOpen }"
        />
      </template>
    </SelectElement>
  </Vueform>
</template>

<style scoped>
.language-switcher {
  @apply w-auto;
}

:deep([role='combobox']) {
  @apply justify-start;
}

:deep(.form-border-width-dropdown) {
  @apply overflow-hidden;
}

:deep(.form-min-h-input-height) {
  @apply h-9 min-h-0;
}
</style>
